import { ChoiceGroup } from '@/common/ui/ChoiceGroup'
import type { DetailedComparisonDetailView, DetailedComparisonFormat } from '../../lib/detailedBrandComparison'
import type { CompanyStatsComparisonMode } from '../../model/useCompanyStatsBrandComparison'
import { Select, SelectOption } from '@/common/ui/Form/Select'
import type { ChangeEvent } from 'react'

type CompanyStatsDetailedBrandComparisonHeaderProps = {
    compareBy: CompanyStatsComparisonMode
    format: DetailedComparisonFormat
    detailView: DetailedComparisonDetailView
    onCompareByChange: (e: ChangeEvent<HTMLSelectElement>) => void
    onFormatChange: (format: DetailedComparisonFormat) => void
    onDetailViewChange: (view: DetailedComparisonDetailView) => void
}

const FORMAT_ITEMS = ['N', '%'] as const
const DETAIL_VIEW_ITEMS = ['Сводно по блокам', 'Детально по критериям'] as const

export const CompanyStatsDetailedBrandComparisonHeader = ({
    compareBy,
    format,
    detailView,
    onCompareByChange,
    onFormatChange,
    onDetailViewChange,
}: CompanyStatsDetailedBrandComparisonHeaderProps) => (
    <div className='flex flex-col gap-4 lg:flex-row justify-between lg:items-center '>
        <div className='flex-1'>
            {compareBy === 'brand'
                ? 'Сводное сравнение брендов портфеля по блокам и отдельным критериям'
                : 'Сводное сравнение продавцов по блокам и отдельным критериям'}
        </div>

        <div className='flex flex-col gap-3 sm:flex-row sm:items-center'>
            <Select value={compareBy} onChange={onCompareByChange} aria-label='Тип детального сравнения' size='lg'>
                <SelectOption value='brand'>Бренды</SelectOption>
                <SelectOption value='seller'>Продавцы</SelectOption>
            </Select>
            <div className='flex items-center gap-2'>
                <span className='text-[10px] font-semibold uppercase tracking-wide text-base-content/50'>Формат</span>
                <ChoiceGroup
                    className='shrink-0'
                    items={[...FORMAT_ITEMS]}
                    activeIndex={format === 'count' ? 0 : 1}
                    onChange={index => onFormatChange(index === 0 ? 'count' : 'percent')}
                />
            </div>

            <ChoiceGroup
                className='shrink-0'
                items={[...DETAIL_VIEW_ITEMS]}
                activeIndex={detailView === 'blocks' ? 0 : 1}
                onChange={index => onDetailViewChange(index === 0 ? 'blocks' : 'criteria')}
            />
        </div>
    </div>
)
